import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HistoryViewComponent } from './history-view/history-view.component';
import { SharedModule } from "../shared/shared.module";
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ImportEffets } from '../stores/global/imports/import.effects';
import { importReducers } from '../stores/global/imports/import-reducers';
import { IndicatorsModule } from "@progress/kendo-angular-indicators";


@NgModule({
  declarations: [
    HistoryViewComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IndicatorsModule,
    StoreModule.forFeature('imports', importReducers),
    EffectsModule.forFeature([ImportEffets]),
  ]
})
export class HistoryModule { }
